import React from 'react';
import * as FiIcons from 'react-icons/fi';

const { FiAlertTriangle } = FiIcons;

// By removing the dynamic `FiIcons[name]` lookup, we allow the bundler 
// to properly tree-shake the react-icons library, reducing main bundle size massively.
const SafeIcon = ({ icon: Icon, className, ...props }) => {
  if (Icon) return <Icon className={className} {...props} />;
  return <FiAlertTriangle className={className} {...props} />;
};

export default SafeIcon;